import { isMobile } from 'APP/Helpers/checkPlatform'
import styled from 'styled-components/native'
import IconCard from 'APP/Converse/IconCard'

export const Container = styled.View`
  padding: ${({ theme }) => (isMobile() ? 0 : theme.metrics.baseMargin * 1.5)}px;
`

export const Form = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: ${isMobile() ? '0px' : '1px'};
  border-right-width: ${isMobile() ? '0px' : '1px'};
  border-color: ${({ theme }) => theme.colors.elementsBorder};
`

export const Disclaimer = styled(IconCard)`
  background-color: ${({ theme }) => theme.colors.selected};
  margin: ${({ theme }) => theme.metrics.baseMargin * 1.5}px 0;
`
